import Bowser from 'bowser';

const parse = (userAgent: string) => Bowser.parse(userAgent);

const isAndroid = (userAgent: string = navigator.userAgent): boolean =>
  parse(userAgent).os.name === 'Android';

const isMobile = (userAgent: string = navigator.userAgent): boolean => {
  const type = parse(userAgent).platform.type;

  return type === 'mobile' || type === 'tablet';
};

export { isAndroid, isMobile };
